import ToggleController from './toggle_controller.js';

export default class extends ToggleController {
}
